/**
 * @generated SignedSource<<8a91dc418fed1e6c23a0a3a725731eaa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type src_businessList_ListViewRoot_queryFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"src_businessList_ListViewWithWorkflow_queryFragment">;
  readonly " $fragmentType": "src_businessList_ListViewRoot_queryFragment";
};
export type src_businessList_ListViewRoot_queryFragment$key = {
  readonly " $data"?: src_businessList_ListViewRoot_queryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"src_businessList_ListViewRoot_queryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "src_businessList_ListViewRoot_queryFragment",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "src_businessList_ListViewWithWorkflow_queryFragment"
    }
  ],
  "type": "Query"
};

(node as any).hash = "0808de8252e260b8784d5c7b742c4f16";

export default node;
